import Backbone from 'backbone';
import QuestionsCollection from 'ef/collections/questions_collection';

const Section = Backbone.Model.extend({
  initialize: function (attrs) {
    this.parse(attrs);
  },
  parse: function (json) {
    this.questions = new QuestionsCollection(json.questions);
    delete json.questions;
    return json;
  },
});

export default Section;
